import { yearOf } from './seatTime';
const activeIn = (r, year)=>{
    const from = yearOf(r.popStart);
    const to = yearOf(r.optionsEnd || r.popEnd);
    if (from === null || r.status === 'future') return false;
    return from <= year && (to === null || to >= year);
};
const uniq = (xs)=>[
        ...new Set(xs)
    ];
/**
 * "Our position" for a calendar year, from the seats alone (GRW-25 item 6, no LLM):
 * Holding / Chasing / Lost / Won {seat}, and "{seat} split". Empty when nothing applies.
 */ export function yearPosition(seats, year) {
    const parts = [];
    for (const s of seats){
        if (s.rounds.some((r)=>r.holderKind === 'us' && activeIn(r, year))) {
            parts.push(`Holding ${s.name}`);
        }
        for (const p of s.pursuits){
            const from = yearOf(p.startedAt);
            const to = yearOf(p.endedAt);
            if (from !== null && from <= year && (to === null || to > year)) {
                parts.push(`Chasing ${s.name}`);
            }
            if (to === year && p.outcome === 'lost') parts.push(`Lost ${s.name}`);
            if (to === year && p.outcome === 'won') parts.push(`Won ${s.name}`);
        }
        if (s.splitFromSeatId && yearOf(s.splitOn) === year) parts.push(`${s.name} split`);
    }
    return uniq(parts).join(' · ');
}
/** "Who held the seats" for a calendar year: "{seat}: {holder}" per seat with a round active then. */ export function yearHolders(seats, year) {
    const parts = [];
    for (const s of seats){
        const held = s.rounds.filter((r)=>activeIn(r, year));
        const r = held[held.length - 1];
        if (r) parts.push(`${s.name}: ${r.holderLabel || (r.holderKind === 'us' ? 'Us' : 'Competitor')}`);
    }
    return parts.join(' · ');
}
